module.exports = __webpack_public_path__ + "img/news27-0.470791cb.png";